import EventRepository from '@/repositories/EventRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'

export interface IFetchCartQueryStatusUseCaseParams {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
}

export default class FetchCartQueryStatusUseCase implements BaseUseCase {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ eventRepository, snapsnapGateway }: IFetchCartQueryStatusUseCaseParams) {
    this.eventRepository = eventRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(params: { eventId: number; isClear?: boolean; }) {
    try {
      const { eventId, isClear } = params
      if (!isClear) {
        const cartQueryStatus = await this.snapsnapGateway.Event.getCartQueryStatus(eventId)
        this.eventRepository.saveCartQueryStatus({ eventId, cartQueryStatus })
        return cartQueryStatus
      } else {
        // APIを叩かず初期値に戻す
        const cartQueryStatus = {
          hasCartQuery: false,
          hasOrderHistory: false
        }
        this.eventRepository.saveCartQueryStatus({ eventId, cartQueryStatus })
      }
    } catch (error) {
      throw error
    }
  }
}
